import { render, staticRenderFns } from "./ExpositorModal.vue?vue&type=template&id=0b376fef&scoped=true"
import script from "./ExpositorModal.vue?vue&type=script&lang=js"
export * from "./ExpositorModal.vue?vue&type=script&lang=js"
import style0 from "./ExpositorModal.vue?vue&type=style&index=0&id=0b376fef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b376fef",
  null
  
)

export default component.exports